import React from 'react'
import { Table } from 'semantic-ui-react'

export const ApiKeysTableHeader: React.FC = () => {
  return (
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell content="Descrição" />
        <Table.HeaderCell content="API" />
        <Table.HeaderCell content="Key" />
        <Table.HeaderCell content="Criação" />
        <Table.HeaderCell content="Expiração" />
        <Table.HeaderCell content="IPs" />
        <Table.HeaderCell />
      </Table.Row>
    </Table.Header>
  )
}
